<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container " >
                <template #default>   <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center d-print-none" >
                <template #default>«ارسال کلیه سفارش‌ها طی ۲ تا ۵ روز کاری پس از ثبت و تأیید نهایی انجام خواهد شد.»   </template>
                </m-Alert-1><m-factor-4 v-bind='{...{"sellerName":"","addressProp":"\u062e\u0648\u0632\u0633\u062a\u0627\u0646 - \u062f\u0632\u0641\u0648\u0644 - \u062e\u06cc\u0627\u0628\u0627\u0646 \u0641\u062a\u062d - \u0628\u06cc\u0646 \u0645\u06cc\u062f\u0627\u0646 \u0634\u0627\u0647\u062f \u0648 \u067e\u0645\u067e \u0628\u0646\u0632\u06cc\u0646 \u0641\u062e\u0631\u0627\u06cc\u06cc - \u0641\u0631\u0648\u0634\u06af\u0627\u0647 \u0644\u0648\u0627\u0632\u0645 \u06cc\u062f\u06a9\u06cc \u0631\u06cc\u0646\u06af \u067e\u06cc\u0633\u062a\u0648\u0646- \u067e\u0644\u0627\u06a9 \u06f1\u06f1\u06f6","meliProp":"","signature":"https:\/\/api.ringpiston.ir\/storage\/icons\/M0sqn6SVhTGcNhxBft7dWrZxC6V5HNuIvryp0ZKW.png","secondImageFactor":""},...{}}' :style='""' class="bg-white p-2 rounded" ></m-factor-4></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mFactor4 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mAlert1,mFactor4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
